
// Dependencies
import React, { Component, PropTypes } from 'react';
import {
  sendConfirmationLink,
  forgotPassword,
  sendSecondaryEmailConfirmation,
  disassociateSecondaryEmail,
  resetPasswordWithToken,
} from '../../stores/sign-in/sign-in-actions';
import debounce from 'lodash.debounce';
// Stores
// Components
import { TextField } from 'material-ui';
import RaisedButton from '../tc-ui/raised-button-with-loader';
import Error from './signin-error';
import { Link } from 'react-router';
// Util
// Put state hydration logic on success here - shouldn't have to do all this state stuff in other components;
import getEnv from '../../utils/env.js';

class SignInLink extends Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.props.debounceDismissInfoBox();
  }

  componentWillReceiveProps() {
    this.props.debounceDismissInfoBox();
  }

  componentWillUnmount() {
    this.props.clearInfoBoxMessage();
  }

  getSubmitFunc() {
    switch (this.props.routeName) {
      case 'forgot-password':
        return forgotPassword;
      case 'disassociate-secondary':
        return disassociateSecondaryEmail;
      case 'resend-confirmation':
        return sendConfirmationLink;
      case 'resend-secondary-confirmation-email':
        return sendSecondaryEmailConfirmation;
      case 'newpassword':
        return resetPasswordWithToken;
      default:
        return resetPasswordWithToken;
    }
  }

  setValue(type) {
    const update = {};
    update[type] = this.refs[type].getValue();
    this.setState(update);
  }

  isValidEmail(email) {
    const filter = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/;
    return String(email).search(filter) !== -1;
  }

  _onSubmit = (event) => {
    this.setState({ sending: true });
    const { token } = this.props.params;
    event.preventDefault();
    // this.setState({sending: true});
    const { dispatch } = this.props;
    const fn = this.getSubmitFunc();
    if (this.props.routeName === 'newpassword') {
      dispatch(fn(this.state.newPassword, token))
      .then(() => {
        this.setState({ sending: false });
        this.props.updateInfoBox({
          signinError: "Your password has been reset. You'll be redirected to our signin page soon.",
          signinInfo: true });
        this.debounceTransition();
      })
      .catch((err) => {
        this.setState({ sending: false });
        if (err.message === 'Not Found') {
          this.props.updateInfoBox({ signinError: 'This link is out of date, please try a new link.', signinInfo: false });
        } else if (err.message === 'Internal Server Error') {
          this.props.updateInfoBox({ signinError: 'Internal Error: Please try again later.', signinInfo: false });
        }
        this.props.debounceDismissInfoBox();
      });
    } else {
      dispatch(fn(this.state.email))
      .then(() => {
        this.setState({ sending: false });
        this.props.updateInfoBox({
          signinError: undefined,
          signinInfo: 'An email has been sent to you.',
        });
        this.props.debounceDismissInfoBox();
      })
      .catch((err) => {
        console.log(err.message);
        this.setState({ sending: false });
        if (err.message === '404') {
          this.props.updateInfoBox({ signinError: "This email doesn't associate with any account.", signinInfo: false });
        } else if (err.message === '400') {
          this.props.updateInfoBox({
            signinError: 'This email has already been confirmed.',
            signinInfo: false });
        } else if (err.message === '500') {
          this.props.updateInfoBox({ signinError: 'Internal Error: Please try again later.', signinInfo: false });
        }
        this.props.debounceDismissInfoBox(this);
      });
    }
  };

  debounceTransition = debounce(() => {
    const { history } = this.props;
    history.push('/signin');
  }, 2000);

  validate() {
    const email = this.state.email;
    if (email === '' || this.isValidEmail(email)) return undefined;
    return 'Please enter a valid email address';
  }

  renderLinksTitle() {
    switch (this.props.routeName) {
      case 'forgot-password':
        return [
            (<Link style={{ fontSize: '12px', display: 'block' }} to={"/signin/resend-confirmation"}>Resend Confirmation Link</Link>),
          'Forgot your password?',
        ];
      case 'disassociate-secondary':
        return [
            (<Link style={{ fontSize: '12px', display: 'block' }} to={"/signin/resend-confirmation"}>Resend Confirmation Link</Link>),
          'Disassociate Secondary Email',
        ];
      case 'resend-confirmation':
        return [
            (<Link style={{ fontSize: '12px', display: 'block' }} to={"/signin/forgot-password"}>Forgot your password?</Link>),
          'Resend Confirmation Link',
        ];
      case 'resend-secondary-confirmation-email':
        return [
          (<div>
            <Link
              style={{ fontSize: '12px', display: 'block' }}
              to={"/signin/resend-confirmation"}
            >
              Resend Confirmation Link
            </Link>
            <Link
              style={{ fontSize: '12px', display: 'block' }}
              to={"/signin/disassociate-secondary"}
            >
              Remove Secondary Email
            </Link>
          </div>),
          'Resend Secondary Email Confirmation',
        ];
      case 'newpassword':
        return [
            (<Link style={{ fontSize: '12px', display: 'block' }} to={"/signin/forgot-password"}>Forgot your password?</Link>),
          'Reset Password',
        ];
      default:
        return [
            (<Link style={{ fontSize: '12px', display: 'block' }} to={"/signin/forgot-password"}>Forgot your password?</Link>),
          'Reset Password',
        ];
    }
  }

  render() {
    let textfield;
    let submitButton;
    let errorText;
    const [links, title] = this.renderLinksTitle();
    if (this.props.routeName !== 'newpassword') {
      textfield = <TextField hintText="Required" floatingLabelText="Email" ref="email" errorText={errorText} onChange={this.setValue.bind(this, 'email')} />;
      if (this.state.sending) submitButton = <RaisedButton style={{ width: '100%', margin: '20px auto' }} className={'signin-button loader'} disabled label={"Submit"}/>;
      else if (!this.isValidEmail(this.state.email)) submitButton = <RaisedButton style={{ width: '100%', margin: '20px auto' }} disabled label={"Submit"}/>;
      else submitButton = <RaisedButton style={{ width: '100%', margin: '20px auto' }} secondary onClick={this._onSubmit} label={"Submit"}/>;
    } else {
      textfield = <TextField hintText="Required" floatingLabelText="New Password" ref="newPassword" type="password" onChange={this.setValue.bind(this, 'newPassword')} />;
      if (this.state.sending) submitButton = <RaisedButton style={{ width: '100%', margin: '20px auto' }} className={'signin-button loader'} disabled label={"Submit"}/>;
      else submitButton = <RaisedButton style={{ width: '100%', margin: '20px auto' }} secondary onClick={this._onSubmit} label={"Submit"}/>;
    }

    if (!this.isValidEmail(this.state.email) && this.state.email) errorText = 'Please enter a valid email address';

    return (
      <div className="user_login">
        <div className="signin_form">
          <h2 className="signin-header">{title}</h2>
          <Error signinError={this.props.signinError} signinInfo={this.props.signinInfo} />
          {textfield}
          {submitButton}
           <div style={{ borderTop: '1px solid #d0d0d0', paddingTop: '10px' }}>
            <Link style={{ fontSize: '12px', display: 'block' }} to="/signin">Sign in</Link>
            {(() => {
              // if production, use external links, Otherwise, add to links Array to be mapped as a legacy link.
              if (getEnv === 'prod') {
                return <a href={`${window.location.protocol}//${window.location.host}/signup`} rel="external" style={{ fontSize: '12px' }}>Sign up</a>;
              }
              return <a href="http://tourconnect2.staging.wpengine.com/sign-up/" style={{ fontSize: '12px', display: 'block' }}>Sign up</a>;
            })()}
          </div>
          {links}
        </div>
      </div>
    );
  }

}

SignInLink.propTypes = {
  debounceDismissInfoBox: PropTypes.func,
  routeName: PropTypes.string,
  params: PropTypes.object,
  history: PropTypes.object,
  dispatch: PropTypes.func,
  updateInfoBox: PropTypes.func,
  clearInfoBoxMessage: PropTypes.func,
  signinError: PropTypes.string,
  signinInfo: PropTypes.boolean,
};

export default SignInLink;

/* jshint ignore:end */



// WEBPACK FOOTER //
// ./src/app/components/signin/links.jsx